/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
// import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';

const Wrapper = styled('div')`
  background-color: #444444;
  width: 100%;
  display: flex;
  padding: 6px 16px 6px 16px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 264px;
  transition: all 250ms ease-in-out;
  :hover {
    opacity: 0.7;
  }
    position: absolute;
    bottom: 0;
    gap: 8px;
`;

const ExerciseDataBaseButton = ({ onClick }) => (
  <Wrapper onClick={onClick}>
    <Text color='white' fontWeight={700} fontSize='16px'>Create New Exercise</Text>
    <IcomoonReact
      iconSet={iconSet}
      size={20}
      icon='circle-arrow'
      color='white'
    />
  </Wrapper>
);

export default ExerciseDataBaseButton;
